"use strict";
exports.__esModule = true;
exports.serialize = exports.buildQueryString = exports.buildAttributesQueryString = void 0;
var attributes_1 = require("./attributes");
var pagination_1 = require("./pagination");
function buildAttributesQueryString(attributes) {
    var attributeString = attributes.map(function (x) { return x.name + ";" + x.value; }).reduce(function (prev, current) { return prev + '|' + current; }, '');
    return attributeString;
}
exports.buildAttributesQueryString = buildAttributesQueryString;
function buildQueryString(state) {
    var queryParams = {};
    var viewName = state.viewName;
    if (state.searchString)
        queryParams.searchString = state.searchString;
    if (state.pagination.currentPageIndex)
        queryParams[viewName + "p"] = state.pagination.currentPageIndex + 1;
    if (state.pagination.currentItemsPerPage)
        queryParams[viewName + "q"] = state.pagination.currentItemsPerPage;
    if (viewName)
        queryParams.view = viewName;
    var sortBy = pagination_1.currentSortBy(state.pagination.sortOptions);
    if (sortBy)
        queryParams[viewName + "s"] = sortBy.name;
    var attributesQueryString = buildAttributesQueryString(attributes_1.selectedAttributes(state.attributes));
    if (attributesQueryString && attributesQueryString.length > 0)
        queryParams[viewName + "c"] = attributesQueryString;
    if (state.dontAutoDirect)
        queryParams["da"] = true;
    if (!!state.originalSearchString)
        queryParams["os"] = state.originalSearchString;
    return serialize(queryParams);
}
exports.buildQueryString = buildQueryString;
function serialize(obj) {
    return '?' + Object.keys(obj)
        .reduce(function (a, k) { a.push(k + '=' + encodeURIComponent(obj[k])); return a; }, [])
        .join('&');
}
exports.serialize = serialize;
